import { useEffect, useState } from "react";
import { applyTheme, loadTheme, type Theme } from "../prefs";
import { Icons } from "./Icons";

const CHOICES: { value: Theme; icon: keyof typeof Icons; label: string }[] = [
  { value: "light", icon: "sun", label: "Light theme" },
  { value: "system", icon: "system", label: "Match system theme" },
  { value: "dark", icon: "moon", label: "Dark theme" },
];

export function ThemePicker() {
  const [theme, setTheme] = useState<Theme>(loadTheme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  return (
    <div className="theme-picker" role="group" aria-label="Colour theme">
      {CHOICES.map((choice) => (
        <button
          key={choice.value}
          type="button"
          title={choice.label}
          aria-label={choice.label}
          aria-pressed={theme === choice.value}
          onClick={() => setTheme(choice.value)}
        >
          {Icons[choice.icon]}
        </button>
      ))}
    </div>
  );
}
